import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import CMCompletionScore from './competency-completion-score/competency-completion-score';
import DefaultMinScore from './default-min-score/default-min-score';
import DefaultPassword from './default-password/default-password';
import DiagnosticLevel from './diagnostic-level/diagnostic-level';
import GroupHeirarchy from './group-heirarchy/group-heirarchy';
import NavigatorClassSetup from './navigator-class-setup/navigator-class-setup';
import ToggleSwitch from './toggle-switch/toggle-switch';
import TxCategoryPrefer from './tx-category-prefer/tx-category-prefer';
import TxFwPrefer from './tx-fw-prefer/tx-fw-prefer';
import TxLoader from './tx-loader/tx-loader';
import TxSubjectPrefer from './tx-subject-prefer/tx-subject-prefer';

@Component({
    name: 'form-loader',
    components: {
        'material-icons': GoogleMaterialIcon,
        'cm-completion-score': CMCompletionScore,
        'tx-preference': TxCategoryPrefer,
        'nav-class-setup': NavigatorClassSetup,
        'default-password': DefaultPassword,
        'toggle-switch': ToggleSwitch,
        'tx-sub-prefer': TxSubjectPrefer,
        'tx-fw-prefer': TxFwPrefer,
        'default-min-score': DefaultMinScore,
        'group-heirarchy': GroupHeirarchy,
        'tx-loader': TxLoader,
        'diagnostic-level': DiagnosticLevel,
    },
})

export default class FormLoader extends Vue {


    @Prop()
    private activeComponent!: string;

    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    private selectedLevel: string = 'categoryLists';

    private selectItem: string = '';

    private contentLoader: any = [];

    @Watch('selectedConfig', { deep: true })
    private watchSelectedConfig(value: any) {
        this.contentLoader = [];
        this.selectItem = 'K12.MA';
        this.loadContent();
    }

    private created() {
        this.loadContent();
    }


    // -------------------------------------------------------------------------------
    // Actions

    private onChangeConfig(config: any) {
        this.$emit('onChangeConfig', config);
    }


    // --------------------------------------------------------------------------------
    // Methods

    private loadContent() {
        const component: any = this;
        if (this.selectedConfig && this.selectedConfig.action) {
            component[`${this.selectedConfig.action}`]();
        }
    }

    private categoryLists() {
        taxonomyAPI.fetchTaxonomyClassifications().then((classification: any) => {
            const subClassification = this.tenantSettings.find((item: any) => item.key === 'tx_sub_classifier_prefs');
            if (subClassification && subClassification.value.ids) {
                const categoryIds = subClassification.value.ids;
                classification = classification.filter((item: any) => categoryIds.indexOf(item.id) !== -1);
            }
            this.contentLoader = classification;
            });

    }

}
